import React from "react";
import styled from "styled-components";
import { Button } from "@mui/material";
import request from "src/utils/request";
import UpgradeCard from "./upgrade-card";
import Auth from "../../services/auth";
import { getRedirectUrl } from "./utils";
import { useAuth } from "../../components/providers/auth-context";

const H2 = styled.h2`
    font-size: 35px;
    margin: 0;
    font-weight: 600;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const CurrencySymbol = styled.span`
    font-size: 20px;
    margin: 0;
    font-weight: 300;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const PerUser = styled.span`
    font-size: 12px;
    margin: 0;
    font-weight: 400;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const Price = () => (
    <H2>
        20<CurrencySymbol>$</CurrencySymbol>
    </H2>
);

const Period = () => <PerUser>/month</PerUser>;

const Action = () => {
    const { isDemo } = useAuth();
    const locationPrefix =
        window.location.hostname === "demo.adadot.com" ? "https://sit.adadot.com" : "";

    const getAction = async (e) => {
        e.preventDefault();
        const url = await request(
            `${locationPrefix}/api/payments/create-checkout-session/team?redirect_uri=${getRedirectUrl()}`,
            { method: "POST", body: JSON.stringify({ lookup_key: "team_plan_metered" }) }
        );
        window.location.replace(url);
    };

    return (
        <form onSubmit={getAction}>
            <input type="hidden" name="lookup_key" value="team_plan_metered" />
            <Button
                id="checkout-and-portal-button"
                variant="contained"
                type="submit"
                color="primary"
                fullWidth
                onClick={(e) => {
                    if (isDemo) {
                        e.preventDefault();
                        Auth.redirectToLogin();
                    }
                }}
                style={{ fontWeight: "bold" }}
            >
                trial team plan
            </Button>
        </form>
    );
};

const UpgradeCardTeam = () => {
    return (
        <UpgradeCard
            listStartItem="Everything in Personal Pro plus:"
            listItems={[
                "Team Analytics",
                "SLA guaranteed uptime",
                "Sharing Permissions",
                "Admin Tools",
            ]}
            pricingItems={[Price, Period]}
            title="team"
            subtitle="For teams up to 10"
            Action={Action}
        />
    );
};

export default UpgradeCardTeam;
